import { Component, OnInit, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_List_Interface, Empty_Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationRequestToStatusService } from 'src/app/Service/Calibration/CalibrationRequestToStatus.service';

@Component({
  selector: 'app-CalibrationInPositionList',
  templateUrl: './CalibrationInPositionList.component.html',
  styleUrls: ['./CalibrationInPositionList.component.scss']
})
export class CalibrationInPositionListComponent implements OnInit {

  @Output() OnBack_Calibration_Action_Form = new EventEmitter<number>();
  @Output() OnBack_Calibration_Action_Form_Schedule = new EventEmitter<number>();
  @Output() OnBack_Calibration_Action_Fund = new EventEmitter<Calibration_List_Interface>();
  @Output() OnBack_Calibration_Action_Certificate = new EventEmitter<Calibration_List_Interface>();
  @Output() OnBack_Calibration_Action_Evaluate = new EventEmitter<Calibration_List_Interface>();

  BaseUrl = environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="
  BaseUrlLetter = environment.BaseUrl
  BaserUrlImage = environment.BaseUrl
  page: number = 0;
  Procssing: boolean = false;

  constructor(
    private Calibration_Service: CalibrationService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService
  ) { }


  DataList_Calibration: Array<Calibration_List_Interface> = []

  ngOnInit() {
    localStorage.removeItem('Daro_User_Comment')
    this.BaseUrl = environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="
    this.Nav_Service.CheckValidPage(1134).subscribe(
      data => {
        this.Read_GetDetailCount()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Filter_customer: String = ''
  Filter_code: String = ''
  Filter_Schdedule: String = ''
  SubmitPeriodDate: string = "1"

  ReadData_Calibration(StartSearchDate, EndSearchDate) {
    this.Procssing = true

    this.Calibration_Service.GetRecord(
      StartSearchDate,
      EndSearchDate,
      this.Filter_customer,
      this.Filter_code,
      this.Filter_Schdedule,
      this.SubmitPeriodDate,
      true).subscribe(
        data => {
          this.DataList_Calibration = data['result']
          this.Procssing = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
  }


  openCalibration: number = 0
  certificate: number = 0
  mission: number = 0


  Read_GetDetailCount() {
    this.Calibration_Service.GetDetailCountInlocation().subscribe(
      data => {
        this.openCalibration = data['openCalibration']
        this.certificate = data['certificate']
        this.mission = data['mission']
      }
    )
  }


  OnSet_Selected_Calibration_Record_Fund(item: Calibration_List_Interface) {
    this.OnBack_Calibration_Action_Fund.emit(item);
  }

  OnSet_Selected_Calibration_Record_Certificate(item: Calibration_List_Interface) {
    this.OnBack_Calibration_Action_Certificate.emit(item);
  }

  OnSet_Selected_Calibration_Record_Evaluate(item: Calibration_List_Interface) {
    this.OnBack_Calibration_Action_Evaluate.emit(item);
  }


  OnBack_Calibration_Action_List(id: number, letterSchedule: string) {
    this.OnBack_Calibration_Action_Form.emit(id);
    this.OnBack_Calibration_Action_Form_Schedule.emit(Number(letterSchedule));
    localStorage.removeItem('Daro_User_Comment')
  }

  Exit_Schedule_Code: String = ''
  Exit_Confirm_Code: String = ''
  modalRef_Exit: any
  openModalExit(template: TemplateRef<any>) {
    this.modalRef_Exit = this.modalService.show(template);
    this.Exit_Schedule_Code = ""
    this.Exit_Confirm_Code = ""
  }


  CodeChangeExit() {
    this.Procssing = true
    this.modalRef_Exit.hide()
    this.LetterRequestCustomer_Service.Confirm_CancelScheduleRequest(this.Exit_Confirm_Code, Number(this.Exit_Schedule_Code)).subscribe(
      data => {
        this.Procssing = false

        if (data['id'] != 0) {
          this.Alertify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Alertify_Service.SuccessMessage("شماره ماموریت " + this.Exit_Schedule_Code + " لغو شد")
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )


  }


  //#region Customer

  modalRef_Customer: any;
  Selected_DataList_Customer: Calibration_List_Interface = Empty_Calibration_List_Interface();
  openModal_Customer(template: TemplateRef<any>, item: Calibration_List_Interface) {
    this.modalRef_Customer = this.modalService.show(template);
    this.Selected_DataList_Customer = item

  }

  //#endregion

  //#region Calibration Status
  CalibrationStatus_Dsc: string = ''
  modalRef_CalibrationStatus: any;
  Selected_DataList_CalibrationStatus: Calibration_List_Interface = Empty_Calibration_List_Interface();
  openModal_CalibrationStatus(template: TemplateRef<any>, item: Calibration_List_Interface) {
    this.modalRef_CalibrationStatus = this.modalService.show(template);
    this.Selected_DataList_CalibrationStatus = item
    this.CalibrationStatus_Dsc=''
  }

  SubmitCalibrationStatus() {
    this.Procssing = true
    this.modalRef_CalibrationStatus.hide()
    this.Calibration_Service.SubmitCalibrationStatus(this.Selected_DataList_CalibrationStatus.id,this.CalibrationStatus_Dsc).subscribe(
      data => {
        this.Procssing = false

        if (data.id == -1) {
          this.Alertify_Service.ErrorMessage("درخواست فعال سازی برای این رسید در سامانه وجود دارد")
        }
        else if (data.id == -2) {
          this.Alertify_Service.ErrorMessage("گردش کار فعالی برای فعال سازی رسید انتخاب نشده است")
        }
        else if (data.id == -3) {
          this.Alertify_Service.ErrorMessage("خطا سیستمی")
        }
        else if (data.id == -4) {
          this.Alertify_Service.ErrorMessage("در چارت سازمانی بدون سمت هستید")
        }
        else if (data.id == -5) {
          this.Alertify_Service.ErrorMessage("امکان فعال سازی رسید به دلیل ثبت گواهی نامه وجود ندارد")
        }
        else {
          this.Alertify_Service.SuccessMessage("درخواست ثبت شد")
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )


  }

  //#endregion


    //#region LetterFile

    modalRef_LetterFile: any;
    LetterFile_Data_List: Array<string> = []
    LetterFile_Data_Code: string = ""
    LetterFile_Data_Tarikh: string = ""
    openModal_LetterFile(template: TemplateRef<any>, item: Calibration_List_Interface) {
      this.modalRef_LetterFile = this.modalService.show(template);
      this.LetterFile_Data_Code = ''
      this.LetterFile_Data_List = []
      this.LetterRequestCustomer_Service.GetLetterRequestCustomerImage(Number(item.code2)).subscribe(
        data => {
          this.LetterFile_Data_List = data['record']
          this.LetterFile_Data_Code = data['code']
          this.LetterFile_Data_Tarikh = data['bazgasht']
        }
      )
    }
  
    //#endregion

}
